// extracted by mini-css-extract-plugin
export default {"pillsTabs":"Settings_pillsTabs__SlTpl"};